// extracted by mini-css-extract-plugin
export default {"pillarCard":"PillarCards_pillarCard__Bwke2","pillarHeading":"PillarCards_pillarHeading__mJoLh","pillarDescription":"PillarCards_pillarDescription__RnaMj"};